module.exports = __webpack_public_path__ + "static/media/create-journey-modal-automagic-button-background.small.84320b91.jpg";